const { USER_APP_ENDPOINT } = require("../secrets");

export const getLogoutUrl = (role= 'MAKER_DESIGNER')=>`${USER_APP_ENDPOINT}/logout?role=${role}`
